import { getStore } from '../store/composeStore';
export default function shouldDisableEncryptionButton(viewState, templateId) {
    var composeStore = getStore();
    // Disable encryption button in following conditions
    // 1. The message is already encrypted with the given templateId, in that case disable the corresponding encryption button
    // 2. Current user is not the message owner
    // 3. Compliance configuration is not ready
    // 4. Compliance configuration does not contain the given templateId
    return ((viewState.IRMData && templateId && viewState.IRMData.RmsTemplateId == templateId) ||
        (viewState.IRMData && !viewState.IRMData.IsOwner) ||
        composeStore.complianceConfigurations.size == 0 ||
        (templateId && !composeStore.complianceConfigurations.has(templateId)));
}
//# sourceMappingURL=shouldDisableEncryptionButton.js.map